import { render, staticRenderFns } from "./NotificationConfig.vue?vue&type=template&id=63d14958&scoped=true"
import script from "./NotificationConfig.vue?vue&type=script&lang=js"
export * from "./NotificationConfig.vue?vue&type=script&lang=js"
import style0 from "./NotificationConfig.vue?vue&type=style&index=0&id=63d14958&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63d14958",
  null
  
)

export default component.exports